import { Link } from "react-router-dom";
import { Ticket, Store, BarChart3, Calendar, TrendingUp, Trophy } from "lucide-react";

/**
 * ComingSoonPage — placeholder for Phase 7-9 features (Tickets, Shop, Fan accounts)
 * Never fake data; clearly labeled as "Coming Soon" while the infrastructure is built.
 */
const ComingSoonPage = ({ title, description, icon: Icon = Store, cta = "/", phase }) => {
  return (
    <div className="min-h-[60vh] bg-gray-50" data-testid="coming-soon-page">
      <section className="bg-[#09090b] py-20">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-block px-3 py-1 bg-[#FFC72C] text-black text-xs font-bold uppercase tracking-widest mb-4">
            {phase || "Coming Soon"}
          </div>
          <Icon className="w-16 h-16 text-[#FFC72C] mx-auto mb-6" />
          <h1 className="font-heading text-5xl md:text-6xl font-bold uppercase text-white mb-4">
            {title}
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            {description}
          </p>
        </div>
      </section>

      <section className="py-16 px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-gray-500 mb-8">
            We're building the next generation of ABFA Football Centre. This feature is part of our phased rollout and will launch soon.
          </p>
          <Link to={cta} className="btn-abfa-primary">
            <span>Back to Home</span>
          </Link>
        </div>
      </section>
    </div>
  );
};

export const TicketsPage = () => (
  <ComingSoonPage
    title="ABFA Tickets"
    description="Centralized ticketing for Premier League matches, international friendlies, national team fixtures, and special events."
    icon={Ticket}
    phase="Phase 7 — Coming Soon"
  />
);

export const ShopPage = () => (
  <ComingSoonPage
    title="ABFA Shop"
    description="Official ABFA merchandise, national team jerseys, Premier League club shirts, training wear, and supporter gear."
    icon={Store}
    phase="Phase 8 — Coming Soon"
  />
);

export const StatisticsPage = () => (
  <ComingSoonPage
    title="Statistics Centre"
    description="Comprehensive statistics for players, clubs, and matches across all ABFA competitions and seasons."
    icon={BarChart3}
    phase="Phase 5 — In Development"
  />
);

export const PlayersPage = () => (
  <ComingSoonPage
    title="Players"
    description="Every registered ABFA player with career history, statistics, appearances, goals, and national team records."
    icon={BarChart3}
    phase="Phase 3 — In Development"
  />
);

// NOTE: PlayersPage placeholder kept for backwards compatibility but /players now routes to PlayersDirectoryPage

export const ResultsPage = () => (
  <ComingSoonPage
    title="Results"
    description="Comprehensive results database across all divisions. For now, results are available in the Fixtures & Results section."
    icon={TrendingUp}
    cta="/fixtures"
  />
);

export const TablesPage = () => (
  <ComingSoonPage
    title="League Tables"
    description="Live and historical league standings. For now, tables are available inside each Competition page."
    icon={Trophy}
    cta="/competitions"
  />
);

export const NationalTeamsPage = () => (
  <ComingSoonPage
    title="National Teams"
    description="Antigua & Barbuda Men's, Women's, U-20, and U-17 national squads. Fixtures, results, and player call-ups."
    icon={Trophy}
    phase="Phase 3 — Coming Soon"
  />
);

export default ComingSoonPage;
